<template lang="html">
   <div class="form-table">
      <div class="table-items" @click="openModal()">
         <div class="text" v-if="tableData.length > 0">{{`${tableData.length}`}} Item(s) Added</div>
         <div class="text" v-else>{{placeholder}}</div>
      </div>

      <Modal 
         type="simple"
         :show="showModal" 
         @close="showModal=false"
      >
         <template slot="content">
            <div class="modal-content">
               <div class="modal-title">
                  <button class="close" @click="showModal = false" aria-label="Close">
                     <span>&times;</span>
                  </button>
               </div>
               <div class="modal-body">
                  <Form 
                     classBinding="row" 
                     :ref="name" 
                     :forms="forms"/>

                  <div class="btn-box clearfix">
                     <button class="btn btn-primary r" @click="addItem()">Add</button>
                  </div>
                  
                  <Table 
                     :table_fields="table.table_fields" 
                     :table_data="tableData" 
                     :title="table.title" 
                     :search_fields="table.search_fields"
                     :row_data="table.row_data"
                     @on-action="handleTableActions"/>
               </div>
               <div class="modal-foot">
                  <div class="btn btn-primary" @click="showModal = false">Close</div>
               </div>
            </div>
         </template>
      </Modal>
   </div>
</template>

<script>
export default {
   components:{
      Form: () => import('./form'),
      Modal: () => import('./modal'),
      Table: () => import('./table/table'),
   },
   props: {
      name: {
         default: 'form-table'
      },
      placeholder: {
         default: 'Click to add items'
      },
      forms: {
         default: function(){
            return []
         }
      },
      table: {
         default: function(){
            return {}
         }
      },
      value: {
         default: function(){
            return []
         }
      }
   },
   watch:{
      value(){
         this.tableData = this.getValidData(this.value)
      }
   },
   data () {
      return {
         showModal: false,
         filesSelected: false,
         fileName: '',
         active: false,
         tableData: this.getValidData(this.value)
      }
   },
   methods: {
      openModal(){
         this.showModal = true
      },
      getValidData(data){
         for (let i = 0; i < data.length; i++) {
            const item = data[i];
            
            if(item.id === undefined || item.id === null){
               item.id = Math.round(Math.random() * 100000);
               data[i] = item;
            }
         }

         return data;
      },
      updateSelf() {
         this.$emit("input", this.tableData);
      },
      async addItem(){
         let ref = this.$refs[this.name]

         if(await ref.isValid()){
            let data = {
               ...ref.formData_,
               id: Math.round(Math.random() * 100000) 
            }

            // Parse through JSON to remove the observable functions
            this.tableData.push(JSON.parse(JSON.stringify(data)))
            ref.resetForms()
            this.updateSelf()
         }
      },
      deleteRow(id){
         for (let i = 0; i < this.tableData.length; i++) {
            const item = this.tableData[i];
            
            if(item.id === id){
               this.tableData.splice(i,1);
               break;
            }
         }

         this.updateSelf()
      },
      handleTableActions(e){
         if(e.action === 'table:delete'){
            this.deleteRow(e.row.id)
         }
      }
   },
}
</script>